<template>
  <div class="apply">
    <div class="title">How to apply for our products?</div>
    <div class="content">
      <div class="left_img">
        <img v-if="activeStep == 0" src="@/assets/step1.png" alt="">
        <img v-if="activeStep == 1" src="@/assets/step2.png" alt="">
        <img v-if="activeStep == 2" src="@/assets/step3.png" alt="">
      </div>
      <div class="step_list">
        <div class="item" :class="activeStep == index ? 'item_active' : ''" v-for="(item,index) in stepList" :key="index" @click="activeStep = index">
          <div class="item_title">{{ item.title }}</div>
          <div class="item_text">{{ item.text }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      activeStep: 0,
      stepList: [
        {
          title: 'Step 1: Register an account',
          text: 'Download Zada Cash, open the app, and register using your phone number and verification code. ',
        },
        {
          title: 'Step 2: Apply for a credit limit',
          text: 'Submit your ID certificate, fill in your basic personal information, and wait for the approval result',
        },
        {
          title: 'Step 3: Submit a loan request',
          text: 'After obtaining your limit, enter your loan amount and disbursement account to submit your loan application.  ',
        },
      ],
    }
  }
}
</script>
<style lang="scss" scoped>
.apply {
  margin-top: 206px;
  .title {
    text-align: center;
    width: 100%;
    font-family: 'Lexend_Medium';
    font-weight: 500;
    font-size: 61px;
    color: #000000;
    line-height: 81px;
  }
  .content {
    margin-top: 84px;
    display: flex;
    justify-content: space-between;
    box-sizing: border-box;
    width: 100%;
    padding: 0 239px 0 178px;
    .left_img {
      width: 597px;
      height: 544px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .step_list {
      padding-top: 63px;
      .item {
        margin-bottom: 86px;
        width: 438px;
        position: relative;
        cursor: pointer;
        &::before {
          content: '';
          position: absolute;
          top: -5px;
          left: -74px;
          width: 57px;
          height: 57px;
        }
        .item_title {
          font-family: 'Lexend_Medium';
          font-weight: 500;
          font-size: 27px;
          color: #29281E;
          line-height: 31px;
        }
        .item_text {
          font-family: 'Lexend_Light';
          font-weight: 300;
          font-size: 17px;
          color: #000000;
          line-height: 23px;
          margin-top: 19px;
        }
      }
      .item:nth-of-type(1) {
        &::before {
          background: url('./../assets/step_icon1.png') 0 0 no-repeat;
          background-size: 100% 100%;
        }
      }
      .item_active:nth-of-type(1) {
        &::before {
          background: url('./../assets/step_icon1_a.png') 0 0 no-repeat;
          background-size: 100% 100%;
        }
      }
      .item:nth-of-type(2) {
        &::before {
          background: url('./../assets/step_icon2.png') 0 0 no-repeat;
          background-size: 100% 100%;
        }
      }
      .item_active:nth-of-type(2) {
        &::before {
          background: url('./../assets/step_icon2_a.png') 0 0 no-repeat;
          background-size: 100% 100%;
        }
      }
      .item:nth-of-type(3) {
        &::before {
          background: url('./../assets/step_icon3.png') 0 0 no-repeat;
          background-size: 100% 100%;
        }
      }
      .item_active:nth-of-type(3) {
        &::before {
          background: url('./../assets/step_icon3_a.png') 0 0 no-repeat;
          background-size: 100% 100%;
        }
      }
      .item_active {
        .item_title,.item_text {
          color: #0053FF;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/HowToApply.vue